"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserFact = void 0;
var Constants_1 = require("../Constants");
var FloodgateEngine_1 = require("../FloodgateEngine");
var Utils = require("../Utils");
var isNOU = Utils.isNOU,
  isNumber = Utils.isNumber,
  isArray = Utils.isArray;
var commonComparatorTypes = [0 /* Equal */, 1 /* NotEqual */, 2 /* GreaterThan */, 3 /* GreaterThanOrEqual */, 4 /* LessThan */, 5 /* LessThanOrEqual */];
var UserFact = /** @class */function () {
  function UserFact(input) {
    this.input = input;
  }
  UserFact.deserialize = function (rawUserFactSpec) {
    return this.validate(rawUserFactSpec) ? new UserFact(rawUserFactSpec) : null;
  };
  UserFact.validate = function (input) {
    if (!input) {
      FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecDeserialization.Failed, "Input is null or undefined for user fact");
      return false;
    }
    // Values is used for type UserFactType.ListOfStrings
    if (!input.Value && input.Values) {
      input.Value = input.Values;
    }
    if (isNOU(input.Name) || isNOU(input.Type) || isNOU(input.Value)) {
      FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecDeserialization.Failed, "Either of the required parameters Name: " + input.Name + ", Type: " + input.Type + " or Value: " + input.Value + " are not provided for the user fact");
      return false;
    }
    if (!this.validateUserFactType(input.Type)) {
      FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecDeserialization.Failed, "Invalid UserFactType value " + input.Type + " is provided for user fact");
      return false;
    }
    if (input.Type === 6 /* ListFile */) {
      FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecDeserialization.Failed, "Unsupported UserFactType value " + input.Type + " is provided for user fact");
      return false;
    }
    if (input.LatencyType && !this.validateLatencyType(input.LatencyType)) {
      FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecDeserialization.Failed, "Invalid LatencyType value " + input.LatencyType + " is provided for user fact of type " + input.Type);
      return false;
    }
    if (input.LatencyType && input.LatencyType !== 0 /* None */ && isNOU(input.LatencyDurationInSeconds)) {
      FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecDeserialization.Failed, "LatencyDurationInSeconds value " + input.LatencyDurationInSeconds + " is not provided for user fact of type " + input.Type);
      return false;
    }
    if (input.LatencyDurationInSeconds && !isNumber(input.LatencyDurationInSeconds)) {
      FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecDeserialization.Failed, "Invalid LatencyDurationInSeconds value " + input.LatencyDurationInSeconds + " is provided for user fact of type " + input.Type);
      return false;
    }
    if (input.Type === 1 /* TimeIntervalInSeconds */ && isNOU(input.IntervalType)) {
      FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecDeserialization.Failed, "Required parameter intervalType is not provided for user fact of type " + input.Type);
      return false;
    }
    var supportedComparatorTypes = this.getComparatorTypes(input.Type);
    if (input.Comparator && !isComparatorTypeSupported(input.Comparator, supportedComparatorTypes)) {
      FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecIsAMatch.Failed, "Unsupported comparator type for user fact of type " + input.Type);
      return false;
    }
    return true;
  };
  UserFact.getComparatorTypes = function (userFactType) {
    switch (userFactType) {
      case 0 /* Boolean */:
        return [0 /* Equal */, 1 /* NotEqual */];
      case 4 /* String */:
        return [0 /* Equal */, 1 /* NotEqual */, 6 /* In */, 7 /* NotIn */];
      case 5 /* ListOfStrings */:
        return [6 /* In */, 7 /* NotIn */];
      case 1 /* TimeIntervalInSeconds */:
      case 2 /* DateTimeUTC */:
      case 3 /* Number */:
      default:
        return commonComparatorTypes;
    }
    return commonComparatorTypes;
  };
  UserFact.assertNever = function (_) {
    return false;
  };
  UserFact.validateLatencyType = function (latency) {
    return latency === 0 /* None */ || latency === 3 /* ClientIngestionDateTime */ || latency === 1 /* SourceDateTime */ || latency === 2 /* StorageDateTime */ ? true : this.assertNever(latency);
  };
  UserFact.validateUserFactType = function (factType) {
    return factType === 0 /* Boolean */ || factType === 2 /* DateTimeUTC */ || factType === 3 /* Number */ || factType === 4 /* String */ || factType === 1 /* TimeIntervalInSeconds */ || factType === 5 /* ListOfStrings */ || factType === 6 /* ListFile */ ? true : this.assertNever(factType);
  };
  UserFact.prototype.isAMatch = function (rawUserFact) {
    if (!rawUserFact || !rawUserFact.userFactValue) {
      return false;
    }
    if (!this.isLatencyAcceptable(rawUserFact)) {
      return false;
    }
    try {
      var factType = this.getType();
      if (factType === 0 /* Boolean */) {
        return compareBooleanValues(this.getValue(), rawUserFact, this.getComparator());
      } else if (factType === 2 /* DateTimeUTC */) {
        return compareDateTimeUTCValues(this.getValue(), rawUserFact, this.getComparator());
      } else if (factType === 3 /* Number */) {
        return compareNumberValues(this.getValue(), rawUserFact, this.getComparator());
      } else if (factType === 4 /* String */) {
        return compareStringValues(this.getValue(), rawUserFact, this.getComparator());
      } else if (factType === 1 /* TimeIntervalInSeconds */) {
        return compareTimeIntervalValues(this.getValue(), rawUserFact, this.getComparator(), this.getIntervalType());
      } else if (factType === 5 /* ListOfStrings */) {
        return compareListValues(this.getValue(), rawUserFact, this.getComparator());
      } else {
        FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecIsAMatch.Failed, "Unsupported type of user fact was provided " + factType);
        return false;
      }
    } catch (error) {
      FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecIsAMatch.Failed, error);
      return false;
    }
  };
  UserFact.prototype.getType = function () {
    return this.input.Type;
  };
  UserFact.prototype.getName = function () {
    return this.input.Name;
  };
  UserFact.prototype.getValue = function () {
    return this.input.Value;
  };
  UserFact.prototype.getComparator = function () {
    return this.input.Comparator || 0 /* Equal */;
  };
  UserFact.prototype.getLatencyType = function () {
    return this.input.LatencyType || 0 /* None */;
  };
  UserFact.prototype.getLatencyDurationInSeconds = function () {
    return this.input.LatencyDurationInSeconds;
  };
  UserFact.prototype.getIntervalType = function () {
    return this.input.IntervalType;
  };
  UserFact.prototype.isLatencyAcceptable = function (rawUserFact) {
    var factType = this.getType();
    if (!isNOU(this.getLatencyDurationInSeconds()) && !evaluateFactCandidacy(this.getLatencyType(), this.getLatencyDurationInSeconds(), rawUserFact)) {
      FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Event(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecIsAMatch.Mismatch, {
        ErrorMessage: "Latency duration not acceptable",
        Type: "" + factType
      });
      return false;
    }
    return true;
  };
  return UserFact;
}();
exports.UserFact = UserFact;
function evaluateFactCandidacy(latencyType, latencyDurationInSeconds, userFact) {
  var userFactTime;
  switch (latencyType) {
    case 0 /* None */:
      break;
    case 1 /* SourceDateTime */:
      userFactTime = userFact.sourceDateTime;
      break;
    case 2 /* StorageDateTime */:
      userFactTime = userFact.storageDateTime;
      break;
    case 3 /* ClientIngestionDateTime */:
      userFactTime = userFact.clientIngestionDateTime;
      break;
  }
  if (!isNOU(userFactTime)) {
    var userFactTimeInMilliseconds = Date.parse(userFactTime);
    var currentTimeInMilliseconds = Date.now();
    return currentTimeInMilliseconds - userFactTimeInMilliseconds <= latencyDurationInSeconds * 1000;
  }
  return true;
}
function compareBooleanValues(userFactSpecValue, rawUserFact, comparator) {
  var rawUserFactValueInBoolean = JSON.parse(rawUserFact.userFactValue.toLowerCase());
  return compareValues(!!userFactSpecValue, !!rawUserFactValueInBoolean, comparator);
}
function compareDateTimeUTCValues(userFactSpecValue, rawUserFact, comparator) {
  var rawUserFactValueInMilliseconds = Date.parse(rawUserFact.userFactValue);
  if (!isAValidNumber(rawUserFactValueInMilliseconds, rawUserFact.userFactValue, rawUserFact.userFactName)) {
    return false;
  }
  var userFactSpecValueInMilliseconds = Date.parse(userFactSpecValue);
  if (!isAValidNumber(userFactSpecValueInMilliseconds, userFactSpecValue, null, 2 /* DateTimeUTC */)) {
    return false;
  }
  return compareValues(userFactSpecValueInMilliseconds, rawUserFactValueInMilliseconds, comparator);
}
function compareNumberValues(userFactSpecValue, rawUserFact, comparator) {
  var rawUserFactValueInNumber = parseInt(rawUserFact.userFactValue, 10);
  if (!isAValidNumber(rawUserFactValueInNumber, rawUserFact.userFactValue, rawUserFact.userFactName)) {
    return false;
  }
  return compareValues(userFactSpecValue, rawUserFactValueInNumber, comparator);
}
function compareStringValues(userFactSpecValue, rawUserFact, comparator) {
  return compareValues(userFactSpecValue.toLowerCase(), rawUserFact.userFactValue.toLowerCase(), comparator);
}
function compareTimeIntervalValues(userFactSpecValue, rawUserFact, comparator, intervalType) {
  var rawUserFactValueInMilliseconds = Date.parse(rawUserFact.userFactValue);
  if (!isAValidNumber(rawUserFactValueInMilliseconds, rawUserFact.userFactValue, rawUserFact.userFactName)) {
    return false;
  }
  // Diff from now and users input date
  // IntervalTo - Internval to current date from fact date (fact date is expected to be before current date)
  // IntervalFrom - Interval from current date to fact date (fact date is expected to be after current date)
  var currentTimeInMilliseconds = Date.now();
  var currentDateDiff = intervalType === 0 /* IntervalTo */ ? currentTimeInMilliseconds - rawUserFactValueInMilliseconds : rawUserFactValueInMilliseconds - currentTimeInMilliseconds;
  if (currentDateDiff < 0) {
    FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Event(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecIsAMatch.Mismatch, {
      ErrorMessage: "Interval type not acceptable",
      Type: "" + 1 /* TimeIntervalInSeconds */
    });
    return false;
  }
  var dayInMilliseconds = 86400000;
  var userFactSpecValueInMilliseconds = userFactSpecValue * dayInMilliseconds;
  // check if the above diff satisfies the comparison criteria
  return compareValues(userFactSpecValueInMilliseconds, currentDateDiff, comparator);
}
function compareListValues(userFactSpecValue, rawUserFact, comparator) {
  return compareValues(userFactSpecValue, rawUserFact.userFactValue, comparator);
}
function isComparatorTypeSupported(comparator, supportedComparatorTypes) {
  return supportedComparatorTypes.indexOf(comparator) !== -1;
}
function compareValues(userFactSpecValue, userFactRawValue, comparator) {
  switch (comparator) {
    case 0 /* Equal */:
      return userFactRawValue === userFactSpecValue;
    case 1 /* NotEqual */:
      return userFactRawValue !== userFactSpecValue;
    case 2 /* GreaterThan */:
      return userFactRawValue > userFactSpecValue;
    case 3 /* GreaterThanOrEqual */:
      return userFactRawValue >= userFactSpecValue;
    case 4 /* LessThan */:
      return userFactRawValue < userFactSpecValue;
    case 5 /* LessThanOrEqual */:
      return userFactRawValue <= userFactSpecValue;
    case 6 /* In */:
      return isFactInSpecItem(userFactSpecValue, userFactRawValue);
    case 7 /* NotIn */:
      return !isFactInSpecItem(userFactSpecValue, userFactRawValue);
  }
}
function isFactInSpecItem(userFactSpecValues, userFactRawValue) {
  if (typeof userFactRawValue === "string") {
    var factValue_1 = userFactRawValue.toLowerCase();
    if (typeof userFactSpecValues === "string") {
      // both the inputs are strings do a plain indexOf
      return userFactSpecValues.toLowerCase().indexOf(factValue_1) !== -1;
    }
    if (isArray(userFactSpecValues)) {
      var specValues = userFactSpecValues;
      return specValues.some(function (specValue) {
        return specValue && specValue.toString().toLowerCase() === factValue_1;
      });
    }
  }
  if (isArray(userFactSpecValues)) {
    return userFactSpecValues.indexOf(userFactRawValue) !== -1;
  }
  return false;
}
function isAValidNumber(numberValue, value, rawUserFactName, factType) {
  if (!isNumber(numberValue)) {
    var errorMessage = "User fact " + rawUserFactName + " has invalid value " + value;
    if (factType) {
      errorMessage = "Invalid value " + value + " was provided for user fact of type " + factType;
    }
    FloodgateEngine_1.FloodgateEngine.getTelemetryLogger().log_Error(Constants_1.TelemetryEvent.Floodgate.UserFactsSpecIsAMatch.Failed, errorMessage);
    return false;
  }
  return true;
}